// @flow
import React, { PureComponent } from 'react'
import type { Node as ReactNode } from 'react'
import { connect } from 'react-redux'
import cn from 'classnames'
import style from './Regular.css'
import { parseUnitsToString } from '../../../../utils/parseUnits/parseUnits'
import { transformBar } from '../../../../utils/barUtils/barUtils'

type Props = {
  data: Object,
  highestNumber: number,
  accent: boolean,
  fields: Object,
  isNotInitialMount: boolean
}
type State = {
  hasMounted: boolean
}

class OneNumberBar extends PureComponent<Props, State> {
  props: Props
  static defaultProps = {
    accent: false,
    isNotInitialMount: false
  }
  state = {
    hasMounted: false
  }
  componentDidMount = () => {
    this.startAnimation(() => this.setState({ hasMounted: true }))
  }

  startAnimation = (callback: Function): void => {
    // has to be nested because of a firefox bug
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        callback()
      })
    })
  }

  render(): ReactNode {
    const { data, highestNumber, accent, fields, isNotInitialMount } = this.props
    const { hasMounted } = this.state
    const valueField = fields.find(f => f.role === 'value')

    const growthInPercent = data[valueField.id] ? (data[valueField.id] / highestNumber) * 100 : 0

    const stringToShow = parseUnitsToString(valueField, data)

    return (
      <tr className={cn(style.onr, { [style.onrAccent]: accent })}>
        <td className={cn(style.onrCol, style.onrColGraph)}>
          <span>{data.name}</span>
          <span
            aria-hidden
            className={cn(style.onrGraph, { [style.onrAccent]: accent })}
            style={
              hasMounted || !isNotInitialMount ? transformBar(growthInPercent) : transformBar(0)
            }
          />
        </td>
        <td className={cn(style.onrCol, style.onrColNumber)}>
          <span className={cn(style.onrNumber)}>{stringToShow}</span>
        </td>
      </tr>
    )
  }
}

const mapStateToProps = ({ parameters }) => {
  return {
    isNotInitialMount: parameters.isNotInitialMount
  }
}

export default connect(mapStateToProps)(OneNumberBar)



// WEBPACK FOOTER //
// ./src/shared/components/Bars/OneNumber/Regular/Regular.js